import { render, staticRenderFns } from "./ThinkClitique.vue?vue&type=template&id=0a0b720c&scoped=true&"
import script from "./ThinkClitique.vue?vue&type=script&lang=js&"
export * from "./ThinkClitique.vue?vue&type=script&lang=js&"
import style0 from "./ThinkClitique.vue?vue&type=style&index=0&id=0a0b720c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b720c",
  null
  
)

export default component.exports